import * as _ from 'lodash'
import React, { Fragment } from 'react';
import * as actions from '../actions';
import util from '../util';
import * as vendorActions from '../vendorActions';import enums from '../enum';
import componentServices from '../componentServices';

import { Expander, sortableComponent } from './sharedComponents';
import VendorEdit from './vendorEdit';
import VendorEditOverview from './vendorEditOverview';
import VendorEditProducts from './vendorEditProducts';
import VendorEditFactors from './vendorEditFactors';
import { getCollection, getModel, ModelCollection } from 'Scripts/store';

const VendorTable = sortableComponent(({ updateSort, sortKey, list, ...childProps }) => {
	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<VendorTableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<VendorTableBody vendorCursor={list} {...childProps} />
		</table>
	);
});

class VendorTableHeader extends React.Component<any,any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}
	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}
	render () {
		return (
			<thead>
				<tr>
					<td />
					<td className={this.getClassName('name')} onClick={this.handleClick.bind(this, 'name')}>Name</td>
					<td className={this.getClassName('primaryContactName')} onClick={this.handleClick.bind(this, 'primaryContactName')}>Primary Contact</td>
					<td className={this.getClassName('workPhoneNumber')} onClick={this.handleClick.bind(this, 'workPhoneNumber')}>Phone Number</td>
					<td />
					<td />
				</tr>
			</thead>
		);
	}
}

const VendorTableBody = ({ vendorCursor, ...childProps }) => {
	const rows:JSX.Element[] = [];
	if (vendorCursor) {
		vendorCursor.forEach((vendor) => {
			rows.push(<VendorTableRow vendor={ vendor } key={vendor.key} {...childProps} />);
		});
	}
	return (<tbody>{rows}</tbody>);
};

class VendorTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick () {
		const { vendor, moduleKey } = this.props;

		componentServices.router.pushHistory(`/${moduleKey}/suppliers/${vendor.key}`);
	}
	render () {
		const { vendor } = this.props;
		return (
			<tr onClick={ this.handleClick} >
				<td />
				<td>{ vendor.name }</td>
				<td>{ vendor.primaryContactName }</td>
				<td>{ vendor.workPhoneNumber }</td>
				<td />
				<td />
			</tr>
		);
	}
}

const VendorHeading = () => {
	const { routeParams, store } = componentServices;
	const vendorKey = routeParams.vendorkey;
	const vendor = vendorKey && getModel({ store, collection: ModelCollection.vendors, key: vendorKey });

	return vendor ? <h1>{ vendor.name }</h1> : null;
};

componentServices.router.addRoutes([{
	path: '/:modulekey/suppliers/:vendorkey/overview',
	component: ({ ...props }) => <VendorEdit {...props}><VendorEditOverview /></VendorEdit>,
	heading: <VendorHeading />,
	contentClass: 'jobDetail'
}, {
	path: '/:modulekey/suppliers/:vendorkey/products',
	component: ({ ...props }) => <VendorEdit {...props}><VendorEditProducts /></VendorEdit>,
	heading: <VendorHeading />,
	contentClass: 'jobDetail'
}, {
	path: '/:modulekey/suppliers/:vendorkey/factors',
	component: ({ ...props }) => <VendorEdit {...props}><VendorEditFactors /></VendorEdit>,
	heading: <VendorHeading />,
	contentClass: 'jobDetail'
}, {
	path: '/:modulekey/suppliers/:vendorkey',
	onEnter: ({ next, replace }) => {
		replace(`/${next.params.modulekey}/suppliers/${next.params.vendorkey}/overview`);
		// cancel the route transition
		return false;
	}
}]);

export default class VendorList extends React.Component<any,any> {
	componentDidMount () {
		actions.setHeaderAction({
			key: 'vendor-add-action',
			element: <button className="icon addBuilder" onClick={this.handleAddVendorClick.bind(this)}><span /></button>
		});

		const { types } = this.props;
		let queryType = 0;
		_.forEach(types, t => {
			queryType |= t;
		});

		vendorActions.fetchVendors({ type: queryType });
	}
	componentWillUnmount () {
		actions.deleteHeaderAction({ key: 'vendor-add-action' });
	}
	handleAddVendorClick (e) {
		e.preventDefault();

		const { moduleKey } = this.props;

		componentServices.router.pushHistory(`/${moduleKey}/suppliers/${util.generateGuid()}`);
	}
	render () {
		const { store } = componentServices;
		const vendors = getCollection({ store, collection: ModelCollection.vendors });
		const { moduleKey, types } = this.props;

		const sections = _.map(types, t => {
			const sectionList = vendors.filter(c => (c.type & t) === t).sortBy(c => c.name);
			const sectionCount = sectionList.count();
			const title = t === enums.vendorTypes.Internal_Warehouse ? enums.vendorTypes.getDisplayName(t) : `${enums.vendorTypes.getDisplayName(t)}s`;

			return (!sectionCount) ? null : (
				<Expander title={ title } isExpanded={ !!sectionCount } key={ t }>
					<VendorTable list={sectionList} initialSortKey="name" moduleKey={ moduleKey } allowedTypes={ types } />
				</Expander>
			);
		});

		return (
			<Fragment>
				{ sections }
			</Fragment>
		);
	}
}
